import { ca } from '@cian/analytics';

import { EEntityType, EDealType } from '../../types/filters';

export function trackApplyFiltersClick({
  dealType,
  favoriteEntityType,
}: {
  dealType: EDealType | null;
  favoriteEntityType: EEntityType | null;
}) {
  const favoriteMap: { [key: string]: string } = {
    [EEntityType.Residential]: 'flat_old',
    [EEntityType.Commercial]: 'commercial',
    [EEntityType.Suburban]: 'suburban',
  };

  ca('eventSite', {
    name: 'oldevent',
    action: 'apply_filter',
    category: 'ListingFavorites',
    label: `${dealType || 'other'}, ${favoriteEntityType ? favoriteMap[favoriteEntityType] : 'other'}`,
  });
}
